import { render, staticRenderFns } from "./RecentLeavesComponent.vue?vue&type=template&id=534383e3&"
import script from "./RecentLeavesComponent.vue?vue&type=script&lang=ts&"
export * from "./RecentLeavesComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports